"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreEvent = void 0;
/**
 * Dispatch and handle events.
 */
class CoreEvent extends CustomEvent {
    constructor(type, eventInitDict) {
        super(type, eventInitDict);
    }
    static dispatch(type, data) {
        console.debug('[CoreEvent] dispatch:', type, data);
        const types = Array.isArray(type) ? type : [type];
        const events = types.map(type => {
            const event = new this(type, { detail: data });
            document.dispatchEvent(event);
            return event;
        });
        return events;
    }
    static handle(type, callback) {
        console.debug('[CoreEvent] handle:', type);
        const listener = event => {
            const data = event.detail;
            console.debug('[CoreEvent] listener: %s, data: %o', type, data);
            callback(data);
        };
        const types = Array.isArray(type) ? type : [type];
        types.forEach(type => document.addEventListener(type, listener));
        return () => {
            console.debug('[CoreEvent] remove:', type);
            types.forEach(type => document.removeEventListener(type, listener));
        };
    }
}
exports.CoreEvent = CoreEvent;
//# sourceMappingURL=event.js.map